// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../imgs/logoBabita.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Cardo:wght@700&family=Inter:wght@400;600&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MOVIMENTAÇÂO CARDS */

.homePage{
    background: var(--whiteNw-pastel-color);
    /* background: linear-gradient(0deg, rgba(166,179,191,1) 0%, rgba(37,45,61,1) 100%); */
    justify-content: flex-start;
    padding-top: 30px;
}

.movList{
    min-height: 75vh;
    max-height: 75vh;
    padding-bottom: 3vh;
}

.homePage .homelogo{
    /* position: absolute; */
    min-width: 250px;
    max-width: 250px;
    /* top: 500px; */
    top: 20vh;
    align-self: center;
    aspect-ratio: 350/111;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: contain;
    background-repeat: no-repeat;
    z-index: 7;
    /* filter: drop-shadow(0px 0px 5px var(--white-color)) drop-shadow(0px 0px 5px #0000004a); */
}

.homePage .subTitleHome{
    width: 100%;
    margin: 0;
    color: #FFFFFF;
    text-align: center;
    font-size: 5em;
}

.homePage .homelogo.logoAnima{
    animation: logoAnimation 0.5s ease-out 0.5s forwards;
}
.homePage .subTitleHome.logoAnima{
    animation: logoAnimation 0.5s ease-out 0.5s forwards;
}

.homeBtnDiv{
    position: absolute;
    display: flex;
    width: fit-content;
    justify-content: space-between;
    top: 40vh;
    z-index: 12;
    align-self: center;
    margin: 0 auto;
    color: var(--white-color);
    font-family: 'Cardo-Bold';
    font-size: 1.3em;
    
}

.homebuttons{
    display: flex;
    justify-self: center;
    align-items: center;
    margin: 0 50px; 
    cursor: pointer;
}

.homePage .homeBtnDiv.btnHomeAnima{
    animation: homeBtnDivAnimation 0.5s ease-out 0.5s forwards;
}


.homebtnText{
    margin-left: 2%;
    text-shadow: 1px 1px 7px #000000aa;
    white-space: nowrap;
}









@media(max-width: 1400px){

    .homePage .homelogo {
        /* position: absolute; */
        min-width: 350px;
        max-width: 350px;
    }

    .homebtnImg {
        width: 70px;
    }

    .homebtnImg::before {
        top: 13px;
        left: 13px;
        width: 40px;
    }

    .homebtnText{
        font-size: 0.8em;
    }
}



@media(max-width: 767px){
    .homePage .homelogo {
        top: 17vh;
        min-width: 60vw;
        max-width: 60vw;
    }
    
    .homePage .homelogo.logoAnima{
        animation: logoAnimation 0.5s ease-out 0.5s forwards;
    }

    .homeBtnDiv{
        flex-direction: column;
        width: 80%;
        top: 36vh;
        left: 0;
    }

    .homebuttons{
        margin-bottom: 5%;
    }

    .homePage .homeBtnDiv.btnHomeAnima{
        animation: homeBtnDivAnimation 0.5s ease-out 0.5s forwards;
    }


    .homePage .subTitleHome{
        width: 100%;
        margin: 0;
        color: #FFFFFF;
        text-align: center;
        font-size: 2em;
    }
    
}





@keyframes logoAnimation {
    0%{
        transform: translateX(200%)
    }
    100%{
        transform: translateX(0%)
    }
}


@keyframes homeBtnDivAnimation {
    0%{
        transform: translateX(200%)
    }
    100%{
        transform: translateX(0%)
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/estiloPaginas/homePage.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAGvB;IACI,uCAAuC;IACvC,sFAAsF;IACtF,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,kBAAkB;IAClB,qBAAqB;IACrB,yDAAkD;IAClD,wBAAwB;IACxB,4BAA4B;IAC5B,UAAU;IACV,4FAA4F;AAChG;;AAEA;IACI,WAAW;IACX,SAAS;IACT,cAAc;IACd,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,oDAAoD;AACxD;AACA;IACI,oDAAoD;AACxD;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,8BAA8B;IAC9B,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB;;AAEpB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,0DAA0D;AAC9D;;;AAGA;IACI,eAAe;IACf,kCAAkC;IAClC,mBAAmB;AACvB;;;;;;;;;;AAUA;;IAEI;QACI,wBAAwB;QACxB,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,SAAS;QACT,UAAU;QACV,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;AACJ;;;;AAIA;IACI;QACI,SAAS;QACT,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,oDAAoD;IACxD;;IAEA;QACI,sBAAsB;QACtB,UAAU;QACV,SAAS;QACT,OAAO;IACX;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,0DAA0D;IAC9D;;;IAGA;QACI,WAAW;QACX,SAAS;QACT,cAAc;QACd,kBAAkB;QAClB,cAAc;IAClB;;AAEJ;;;;;;AAMA;IACI;QACI;IACJ;IACA;QACI;IACJ;AACJ;;;AAGA;IACI;QACI;IACJ;IACA;QACI;IACJ;AACJ","sourcesContent":["/* MOVIMENTAÇÂO CARDS */\r\n@import url('https://fonts.googleapis.com/css2?family=Cardo:wght@700&family=Inter:wght@400;600&display=swap');\r\n\r\n.homePage{\r\n    background: var(--whiteNw-pastel-color);\r\n    /* background: linear-gradient(0deg, rgba(166,179,191,1) 0%, rgba(37,45,61,1) 100%); */\r\n    justify-content: flex-start;\r\n    padding-top: 30px;\r\n}\r\n\r\n.movList{\r\n    min-height: 75vh;\r\n    max-height: 75vh;\r\n    padding-bottom: 3vh;\r\n}\r\n\r\n.homePage .homelogo{\r\n    /* position: absolute; */\r\n    min-width: 250px;\r\n    max-width: 250px;\r\n    /* top: 500px; */\r\n    top: 20vh;\r\n    align-self: center;\r\n    aspect-ratio: 350/111;\r\n    background-image: url('../../imgs/logoBabita.png');\r\n    background-size: contain;\r\n    background-repeat: no-repeat;\r\n    z-index: 7;\r\n    /* filter: drop-shadow(0px 0px 5px var(--white-color)) drop-shadow(0px 0px 5px #0000004a); */\r\n}\r\n\r\n.homePage .subTitleHome{\r\n    width: 100%;\r\n    margin: 0;\r\n    color: #FFFFFF;\r\n    text-align: center;\r\n    font-size: 5em;\r\n}\r\n\r\n.homePage .homelogo.logoAnima{\r\n    animation: logoAnimation 0.5s ease-out 0.5s forwards;\r\n}\r\n.homePage .subTitleHome.logoAnima{\r\n    animation: logoAnimation 0.5s ease-out 0.5s forwards;\r\n}\r\n\r\n.homeBtnDiv{\r\n    position: absolute;\r\n    display: flex;\r\n    width: fit-content;\r\n    justify-content: space-between;\r\n    top: 40vh;\r\n    z-index: 12;\r\n    align-self: center;\r\n    margin: 0 auto;\r\n    color: var(--white-color);\r\n    font-family: 'Cardo-Bold';\r\n    font-size: 1.3em;\r\n    \r\n}\r\n\r\n.homebuttons{\r\n    display: flex;\r\n    justify-self: center;\r\n    align-items: center;\r\n    margin: 0 50px; \r\n    cursor: pointer;\r\n}\r\n\r\n.homePage .homeBtnDiv.btnHomeAnima{\r\n    animation: homeBtnDivAnimation 0.5s ease-out 0.5s forwards;\r\n}\r\n\r\n\r\n.homebtnText{\r\n    margin-left: 2%;\r\n    text-shadow: 1px 1px 7px #000000aa;\r\n    white-space: nowrap;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n@media(max-width: 1400px){\r\n\r\n    .homePage .homelogo {\r\n        /* position: absolute; */\r\n        min-width: 350px;\r\n        max-width: 350px;\r\n    }\r\n\r\n    .homebtnImg {\r\n        width: 70px;\r\n    }\r\n\r\n    .homebtnImg::before {\r\n        top: 13px;\r\n        left: 13px;\r\n        width: 40px;\r\n    }\r\n\r\n    .homebtnText{\r\n        font-size: 0.8em;\r\n    }\r\n}\r\n\r\n\r\n\r\n@media(max-width: 767px){\r\n    .homePage .homelogo {\r\n        top: 17vh;\r\n        min-width: 60vw;\r\n        max-width: 60vw;\r\n    }\r\n    \r\n    .homePage .homelogo.logoAnima{\r\n        animation: logoAnimation 0.5s ease-out 0.5s forwards;\r\n    }\r\n\r\n    .homeBtnDiv{\r\n        flex-direction: column;\r\n        width: 80%;\r\n        top: 36vh;\r\n        left: 0;\r\n    }\r\n\r\n    .homebuttons{\r\n        margin-bottom: 5%;\r\n    }\r\n\r\n    .homePage .homeBtnDiv.btnHomeAnima{\r\n        animation: homeBtnDivAnimation 0.5s ease-out 0.5s forwards;\r\n    }\r\n\r\n\r\n    .homePage .subTitleHome{\r\n        width: 100%;\r\n        margin: 0;\r\n        color: #FFFFFF;\r\n        text-align: center;\r\n        font-size: 2em;\r\n    }\r\n    \r\n}\r\n\r\n\r\n\r\n\r\n\r\n@keyframes logoAnimation {\r\n    0%{\r\n        transform: translateX(200%)\r\n    }\r\n    100%{\r\n        transform: translateX(0%)\r\n    }\r\n}\r\n\r\n\r\n@keyframes homeBtnDivAnimation {\r\n    0%{\r\n        transform: translateX(200%)\r\n    }\r\n    100%{\r\n        transform: translateX(0%)\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
